import {
  ChangeDetectionStrategy, ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import {interval, Subscription} from "rxjs";
import * as moment from "moment";
import {BringozTimeAgoPipe} from "../../pipes/bringoz-time-ago.pipe";

require('./bringoz-countdown.scss');
@Component({
  standalone: false,
  selector: 'app-bringoz-countdown',
  templateUrl: './bringoz-countdown.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BringozCountdownComponent implements OnInit, OnChanges, OnDestroy {
  @Input() from: any;
  @Input() to: any;
  @Input() maxCount: any;
  @Input() keepCountWhenNegative: any;
  @Input() stopCount: any;
  @Input() negativeUntilFrom: boolean;
  @Output() currentTimeChangedEvent = new EventEmitter<null>();

  public isLate: boolean;
  public DEFAULT_MAX_COUNT: any;
  public displayTime: any;
  private countDownIntervalRef: Subscription;

  constructor(@Inject(BringozTimeAgoPipe) private bringozTimeAgoPipe: BringozTimeAgoPipe, @Inject(ChangeDetectorRef) private cdr: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.DEFAULT_MAX_COUNT = 30; // In Minutes
    this.maxCount = (this.maxCount || this.DEFAULT_MAX_COUNT) * 60000;
    this._setDisplayTime();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.from || changes.to) {
      this.resetInterval();
    }
    if (changes.maxCount && !changes.maxCount.isFirstChange()) {
      this.resetInterval();
    }
  }

  ngOnDestroy() {
    if (this.countDownIntervalRef) {
      this.countDownIntervalRef.unsubscribe();
    }
  }

  private resetInterval() {
    if (!this.countDownIntervalRef && !!this.stopCount) {
      this._setDisplayTime();
    } else {
      if (!!this.countDownIntervalRef) {
        this.displayTime = undefined;
        this.countDownIntervalRef.unsubscribe();
        this.countDownIntervalRef = undefined;
      }
      this.countDownIntervalRef = interval(1000).subscribe(() => {
        this._setDisplayTime();
        this.cdr.detectChanges();
      });
    }
  }

  private _setDisplayTime() {
    const from = this.from || moment().valueOf()
    const until = this.to || (from + this.maxCount);
    const showTimer = this.keepCountWhenNegative || ((this.from || this.to) ? moment().isBefore(moment(until)) : false);
    const diffInHours = moment(until).diff(moment(), 'hours');

    if (!showTimer && (diffInHours >= 24 || diffInHours <= -24)) {
      this.displayTime = this.bringozTimeAgoPipe.transform(until);
    } else {
      const seconds = showTimer ? moment(until).diff(from, 'seconds') : 0;
      let duration = moment.duration(Math.abs(seconds), 'seconds');

      let daysRef = duration.days(),
        hoursRef = duration.hours(),
        minutesRef = duration.minutes(),
        secondsRef = duration.seconds()


      let displayTime = `${this._getPaddingZeroNumber(hoursRef)}:${this._getPaddingZeroNumber(minutesRef)}:${this._getPaddingZeroNumber(secondsRef)}`
      if (daysRef > 0) {
        displayTime = `${this._getPaddingZeroNumber(daysRef)}:${displayTime}`
      }

      this.displayTime = displayTime;
      if (this.currentTimeChangedEvent) {
        this.currentTimeChangedEvent.emit();
      }

    }
    this.isLate = moment(until).isBefore(moment())

  }

  private _getPaddingZeroNumber(number) {
    return number.toLocaleString('en-US', {
      minimumIntegerDigits: 2,
      useGrouping: false
    })
  }

}
